import { render } from "./Periodontology.vue?vue&type=template&id=fa2f7910"
import script from "./Periodontology.vue?vue&type=script&lang=js"
export * from "./Periodontology.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__